const setEditUser = async ({ commit }, user) => {
  commit('SET_EDIT_USER', user);
};

export default {
  setEditUser,
};
